module.exports = __webpack_public_path__ + "static/media/logo-harman.e492ca2c.svg";